import { Group } from "@mantine/core"
import { OperationsAdminVenueAreaTabs } from "src/components/operations/administrator/areas/OperationsAdminVenueAreaTabs"
import { EditOperationsAdminVenueAreaAction } from "src/components/operations/administrator/areas/OperationsAdminVenueAreaActions"
import { PageHeader } from "src/components/ui/PageHeader"
import { PageLayout } from "src/components/ui/PageLayout"
import { useAppState } from "src/state"
import { OperationsAdminVenueAreaView } from "src/components/operations/administrator/areas/OperationsAdminVenueAreaView"

export function OperationsAdminVenueArea() {

    const { currentItem } = useAppState(state=>state.areas)

    return (
        <PageLayout
            header={
                <PageHeader
                    title={`${currentItem?.name}`}
                    renderAction={
                        <Group gap="sm">
                            <EditOperationsAdminVenueAreaAction />
                        </Group>
                    }
                />
            }
        >
            <OperationsAdminVenueAreaTabs/>
            <OperationsAdminVenueAreaView/>
        </PageLayout>
    )

}